/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

/**
 * Smart utility to avoid unnecessary selections in explore
 * 
 * @param {Object} dashboardApi - dashboard API
 * @param {[string]} contentIds - array of content ids to select
 */
export const performContentSelection = (dashboardApi, contentIds) => {
	const canvas = dashboardApi.getFeature('Canvas');
	const selectedContents = canvas.getSelectedContentList();
	const toSelect = [];
	const toDeselect = [];
	const _contentIds = contentIds.concat();
	selectedContents.forEach(content => {
		const contentId = content.getId();
		const idIndex = contentIds.indexOf(contentId);
		if (idIndex === -1) {
			toDeselect.push(contentId);
		} else {
			_contentIds.splice(idIndex, 1);
		}
	});

	if (_contentIds.length > 0) {
		toSelect.push(..._contentIds);
	}

	if (toSelect.length > 0) {
		canvas.selectContent(toSelect);
	}
	if (toDeselect.length > 0) {
		canvas.deselectContent(toDeselect);
	}
};


// WEBPACK FOOTER //
// ./src/js/util/SelectionUtil.js